import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import BaseLayout from "../../components/BaseLayout";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { priceDecimal } from "../../utils/utilities";
import RewardContent from "./rewardContent";
import DiscountContent from "./discountContent";
import ApiUtils from "../../utils/api_utils";
import { rewardCategory } from "../../utils/constant";
import Tabs from "../../components/Tabs";
import "./style.scss";

const HeaderReward = (props) => {
  return (
    <div
      className="reward-header"
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + "/SKOR-Reward-Header-Bg.png"
        })`,
      }}
    >
      <Row className="reward-header-logo">
        <Col xs={10} sm={10} md={10} className="header-left">
          {props.isLogo ? (
            <img
              src={ApiUtils.validateImgUrl({ url: props.logo })}
              className="logo-img"
              alt="logo_image"
            />
          ) : (
            <p>{props.name}</p>
          )}
        </Col>
        <Col
          xs={2}
          sm={2}
          md={2}
          className="header-right"
          onClick={() => {
            props.navigate(PageRoutes.underDevelopment);
          }}
        >
          <img
            src={Assets.iconNotification}
            className="notif-img"
            alt="notif_image"
          />
        </Col>
      </Row>
      <Row className="reward-header-label">
        <Col
          xs={5}
          sm={5}
          md={5}
          className="header-left"
          onClick={() => {
            props.navigate(PageRoutes.account);
          }}
        >
          <img
            src={Assets.iconProfileLevel}
            className="basic-img"
            alt="basic_image"
          />
          Basic
        </Col>
        <Col
          xs={7}
          sm={7}
          md={7}
          className="header-right"
          onClick={() => {
            props.navigate(PageRoutes.home);
          }}
        >
          <img
            src={props.activeTabs === 1 ? Assets.iconOval : Assets.iconStar}
            className="point-img"
            alt="point_image"
          />
          {props.activeTabs === 1
            ? `${priceDecimal(props.totalPoint)} Points`
            : `${priceDecimal(props.totalStar)} Stars`}
        </Col>
      </Row>
    </div>
  );
};

const RewardPage = (props) => {
  const navigate = useNavigate();
  const { typeTab } = useParams();

  const { profile, pwa_setting, getTotal } = props;

  const [activeTabs, setActiveTabs] = useState(
    typeTab
      ? profile.has_discount_categories === true
        ? 2
        : 1
      : profile.has_point_categories === true
      ? 1
      : 2
  );
  const [totalPoint, setTotalPoint] = useState(0);
  const [totalStar, setTotalStar] = useState(0);

  const onChangeTabs = (tabActive) => {
    setActiveTabs(tabActive);
  };

  useEffect(() => {
    getTotal()
      .then((response) => {
        setTotalPoint(response.data.points.value);
        setTotalStar(response.data.stars.value);
      })
      .catch((error) => {
        setTotalPoint(0);
        setTotalStar(0);
      });
  }, []);

  return (
    <BaseLayout
      show_menu={pwa_setting.show_main_menu}
      bottomNavIndex={1}
      header={
        <HeaderReward
          activeTabs={activeTabs}
          isLogo={profile.organization_structure_label[0].organization.use_icon}
          name={profile.organization_structure_label[0].organization.name}
          logo={
            profile.organization_structure_label[0].organization
              .organization_icon !== ""
              ? profile.organization_structure_label[0].organization
                  .organization_icon
              : Assets.logo
          }
          navigate={navigate}
          totalPoint={totalPoint}
          totalStar={totalStar}
        />
      }
    >
      <div className="reward-nav">
        <div className="d-flex wrapper-tab align-items-center overflow-unset">
          {rewardCategory.map((cat, index) => {
            if (
              (profile.has_point_categories == false && cat.key === "reward") ||
              (profile.has_discount_categories == false &&
                cat.key === "discount")
            ) {
              return "";
            } else {
              return (
                <Tabs
                  id={cat.id}
                  key={index}
                  name={cat.name}
                  isActive={activeTabs}
                  onClick={() => {
                    if (cat.id === 3) {
                      navigate(PageRoutes.myVoucher);
                    } else {
                      onChangeTabs(cat.id, cat.name);
                    }
                  }}
                />
              );
            }
          })}
        </div>
        {activeTabs === 1 && profile.has_point_categories === true && (
          <Row className="reward-content">
            <RewardContent totalPoint={totalPoint} />
          </Row>
        )}

        {activeTabs === 2 && profile.has_discount_categories === true && (
          <Row className="discount-content">
            <DiscountContent totalPoint={totalPoint} />
          </Row>
        )}
      </div>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  profile: state.LoginSM.login,
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
});

const mapDispatchToProps = (dispatch) => ({
  getTotal: dispatch.FinanceSM.getTotal,
});

export default connect(mapStateToProps, mapDispatchToProps)(RewardPage);
